import { render, staticRenderFns } from "./CottonDynamicForm.vue?vue&type=template&id=04097c88&"
import script from "./CottonDynamicForm.vue?vue&type=script&lang=js&"
export * from "./CottonDynamicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports